import { create } from 'zustand';

type CancelledOrdersById = Record<string, true>;
type CancelledOrdersState = {
  cancelledOrdersById: CancelledOrdersById;
  setOrder: (id: string) => void;
  removeOrder: (id: string) => void;
};
/**
 * This store is used to optimistically remove cancelled from the order endpoint.
 * It's up to consumers to fallback and reset the order if the cancellation fails.
 */
export const useCancelOrderStore = create<CancelledOrdersState>((set) => ({
  cancelledOrdersById: {},

  setOrder: (id: string) =>
    set((state) => ({
      cancelledOrdersById: { ...state.cancelledOrdersById, [id]: true },
    })),
  removeOrder: (id: string) =>
    set((state) => {
      const { [id]: _, ...rest } = state.cancelledOrdersById;
      return { cancelledOrdersById: rest };
    }),
}));
